import { type DefaultContext, gqlPromise } from '@egw/clients'
import { type CustomerDetails } from '../../models'

/**
 * Get customer details based on auth session
 * @param context - reference to the AbortController used to abort the call (optional)
 * @returns Promise<CustomerDetails>
 * @example const customerDetails = await getCustomerDetails();
 */
export const getCustomerDetails = async (context?: DefaultContext): Promise<CustomerDetails> => {
  const response = (await gqlPromise(
    {
      name: 'customerDetails',
      query: `
        query customerDetails {
          customer {
            name {
              firstName
              lastName
            }
            address {
              line1
              line2
              city
              region
              postalCode
              country
            }
            phone {
              countryPhoneCode
              phoneNumber
            }
            email
            linkedAccounts {
              achAccounts {
                alias
                name
                mask
                achType
                linkedAccountStatus
                institutionName
                identifier
              }
              isSingleRestricted
            }
            externalAccounts {
              institutions {
                __typename
                institutionId
                institutionName
                linkedInstitutionStatus
                accounts {
                  __typename
                  alias
                  name
                  externalBalance {
                    balance
                    currencyCode
                    lastUpdated
                  }
                }
              }
            }
            ssnLastFour
            birthDate
            tags
            attributes {
              firstDeposit
            }
            lastLogin
            createdDate
            employmentStatus
            occupation
            personalAnnualGrossIncome
            personalNetWorthRange
            maritalStatus
            isBrokerDealer
            brokerDealerEmployer
            isDirectorPolicyMakerOfCompany
            directorPolicyMakerOfCompany
            taxFilingStatus
            investmentObjective
            investmentExperience
            isPoliticallyExposedPerson
            affiliatedPoliticalOrganizations
            hasPoliticallyExposedImmediateFamilyMembers
            politicallyExposedImmediateFamilyMembers
          }
          customerService {
            tokens {
              helpCenterToken
              inAppChatToken
            }
          }
        }`,
    },
    context,
  )) as CustomerDetails
  return response
}
